import type { Href, Router } from 'expo-router';

export function dismissToServiceRoute(router: Pick<Router, 'dismissTo'>, href: Href) {
  router.dismissTo(href);
}

export function dismissToServices(router: Pick<Router, 'dismissTo'>) {
  dismissToServiceRoute(router, '/services' as Href);
}
